/* Built In Imports */
import React from 'react';

/* External Imports */
import { Box, Button, Link } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import { refineUrlDomain } from '@components/Utility/utils';
/* Services */

/**
 * Renders the SgX Try For Free Button component
 *
 * @param {object} sectionContent - Data for section
 * @param {string} region - Region of the section
 * @param {string} language - Language of the section
 */

const BtnTryForFree = ({
  sectionContent,
  region,
  language,
  PackageData,
  period,
  eventname,
}) => {
  const formsubmit = () => {
    window.dataLayer.push({ event: eventname });
  };
  const posturl = refineUrlDomain(sectionContent?.linkUrl, region, language);
  return (
    <Box textAlign="center" onClick={formsubmit}>
      <form
        id="subscribeplan"
        method="post"
        name="subscribe"
        action={posturl}
        enctype="application/json"
      >
        <input
          type="hidden"
          name="package"
          id="package_name"
          value={
            period !== 'monthly'
              ? PackageData[0]?.package_name
              : PackageData[1]?.package_name
          }
        />
        <input
          type="hidden"
          name="country"
          id="iso2"
          value={
            period !== 'monthly' ? PackageData[0]?.iso2 : PackageData[1]?.iso2
          }
        />
        <input
          type="hidden"
          name="planfee"
          id="package_amount"
          value={
            period !== 'monthly'
              ? PackageData[0]?.package_amount
              : PackageData[1]?.package_amount
          }
        />
        <input
          type="hidden"
          name="offer"
          id="offer_code"
          value={period !== 'monthly' ? 'ANNUAL14DAY' : ''}
        />
        <Button
          background="#ffbd31"
          _hover={{ background: '#ffbd31' }}
          _active={{ background: '#ffbd31' }}
          _focus={{ boxShadow: 'none' }}
          w={{ base: '98%', md: '414px' }}
          m="14px auto 0"
          height="81px"
          fontWeight="normal"
          cursor="pointer"
          color="#ffbd31"
          type="submit"
          borderRadius="7px"
          padding={{ base: '14px 46px', md: '14px 35px' }}
          whiteSpace="unset"
          lineHeight="26px"
        >
          <Link
            m="2px auto 0"
            fontFamily="FedraSansStd-A-medium"
            fontSize={{ base: '18px', lg: '20px' }}
            textAlign="center"
            display="block"
            color="#2c2a29"
            _hover={{ textDecor: 'none' }}
          >
            {sectionContent.buttonText}
          </Link>
        </Button>
      </form>
    </Box>
  );
};

export default BtnTryForFree;
